import { IBackgroundType } from "./types";

export const backgroundVariant: Record<IBackgroundType, string> = {
  LIGHT_BLUE: "linear-gradient(to bottom, #68e3ef, #37c2da)",
  DARK_BLUE: " linear-gradient(to bottom, #9ab1ff, #6179ff)",
  RED: "linear-gradient(to bottom, #ff9399, #ff5a60)",
};
